<template>
	<el-dialog
		title="资源签约"
		:visible.sync="dialogVisible"
		width="40%"
		top="10vh"
		:close-on-click-modal="false"
		:before-close="handleClose"
		custom-class="plan-dialog">
		<el-form ref="form" :model="form" :rules="rules" label-position="top" size="mini">
			<el-row :gutter="20">
				<!-- 资源编号 -->
				<el-col :span="12">
					<el-form-item label="资源编号" prop="resourceNo">
						<el-input v-model="form.resourceNo" size="small" placeholder="请填写资源编号" disabled />
					</el-form-item>
				</el-col>

				<!-- 资源名称 -->
				<el-col :span="12">
					<el-form-item label="资源名称" prop="resourceName">
						<el-input v-model="form.resourceName" size="small" placeholder="请填写资源名称" disabled />
					</el-form-item>
				</el-col>

				<!-- 租客名称 -->
				<el-col :span="12">
					<el-form-item label="租客名称" prop="partyBName">
						<el-input v-model="form.partyBName" size="small" placeholder="请填写租客名称" />
					</el-form-item>
				</el-col>

				<!-- 租客电话 -->
				<el-col :span="12">
					<el-form-item label="租客电话" prop="partyBPhone">
						<el-input v-model="form.partyBPhone" size="small" placeholder="请填写租客电话" />
					</el-form-item>
				</el-col>

				<!-- 签约日期 -->
				<el-col :span="12">
					<el-form-item label="签约日期" prop="signDate">
						<el-date-picker
							v-model="form.signDate"
							type="date"
							placeholder="请选择签约日期"
							size="small"
							style="width: 100%"
							format="yyyy-MM-dd"
							value-format="yyyy-MM-dd" />
					</el-form-item>
				</el-col>

				<!-- 到期日期 -->
				<el-col :span="12">
					<el-form-item label="到期日期" prop="expiryDate">
						<el-date-picker
							v-model="form.expiryDate"
							type="date"
							placeholder="请选择到期日期"
							size="small"
							style="width: 100%"
							format="yyyy-MM-dd"
							value-format="yyyy-MM-dd" />
					</el-form-item>
				</el-col>

				<!-- 租金单价 -->
				<el-col :span="12">
					<el-form-item label="租金单价" prop="unitPrice">
						<el-input
							v-model.number="form.unitPrice"
							type="number"
							size="small"
							placeholder="请填写租金单价"
							class="no-spinner" />
					</el-form-item>
				</el-col>

				<!-- 月租金 -->
				<el-col :span="12">
					<el-form-item label="月租金" prop="price">
						<el-input
							v-model.number="form.price"
							type="number"
							size="small"
							placeholder="请填写月租金"
							class="no-spinner" />
					</el-form-item>
				</el-col>

				<!-- 支付方式 -->
				<el-col :span="12">
					<el-form-item label="支付方式" prop="rentCycle">
						<el-select v-model="form.rentCycle" placeholder="请选择支付方式" size="small">
							<el-option
								v-for="(item, index) in $menu.getList('RentCycle')"
								:key="index"
								:label="item.name"
								:value="item.value" />
						</el-select>
					</el-form-item>
				</el-col>

				<!-- 押金金额 -->
				<el-col :span="12">
					<el-form-item label="押金金额" prop="deposit">
						<el-input
							v-model.number="form.deposit"
							type="number"
							size="small"
							placeholder="请填写押金金额"
							class="no-spinner" />
					</el-form-item>
				</el-col>

				<!-- 合同内容 -->
				<el-col :span="24">
					<el-form-item label="合同内容" prop="content">
						<!-- <el-input
							type="textarea"
							v-model="form.content"
							size="small"
							placeholder="请填写租赁条款、双方权利义务"
							:rows="4" /> -->
						<RichTextEditor v-model="form.content" />
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item label="附件上传" prop="url">
						<FileUpload
							ref="upload"
							:limit="1"
							:showTip="false"
							:accept="['jpg', 'png', 'pdf']"
							v-model="fileList"
							@success="handleUploadSuccess"
							title="上传合同扫描件、租客身份证明"></FileUpload>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>

		<!-- 按钮 -->
		<span slot="footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import { getContractSave } from '@/api/contracts/contractApi.js';
	import RichTextEditor from '../editor/RichTextEditor.vue';
	import { getCommunityId } from '@/utils/vc.js';
	export default {
		name: 'ResourceManageSignDialog',
		components: { RichTextEditor },
		props: {
			dialogVisible: Boolean,
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						this.$refs.form && this.$refs.form.resetFields();
						this.form.resourceNo = this.data.resourceNo || '';
						this.form.resourceName = this.data.resourceName || '';
						this.form.resourceId = this.data.id || '';
					});
				} else {
					this.$refs.upload.reset();
				}
			},
		},
		data() {
			return {
				fileList: [],
				form: {
					contractType: 'CONTRACT',
					resourceNo: '',
					resourceName: '',
					partyBName: '',
					partyBPhone: '',
					communityId: getCommunityId(),
					resourceId: '',
					signDate: '',
					expiryDate: '',
					price: '',
					unitPrice: '',
					rentCycle: '',
					deposit: '',
					content: '',
					url: '',
				},
				rules: {
					resourceNo: { required: true, message: '请填写资源编号', trigger: 'blur' },
					resourceName: { required: true, message: '请填写资源名称', trigger: 'blur' },
					partyBName: [
						{ required: true, message: '请填写租客名称', trigger: 'blur' },
						{ min: 2, max: 15, message: '租客名称长度应为2~15个字符', trigger: 'blur' },
					],
					partyBPhone: [
						{ required: true, message: '请填写租客电话', trigger: 'blur' },
						{ pattern: /^1[3-9]\d{9}$/, message: '请填写正确的手机号', trigger: 'blur' },
					],
					signDate: { required: true, message: '请选择签约日期', trigger: 'change' },
					expiryDate: { required: true, message: '请选择到期日期', trigger: 'change' },
					unitPrice: [
						{ required: true, message: '请填写租金单价', trigger: 'blur' },
						{ type: 'number', min: 0, message: '租金单价必须大于0', trigger: 'blur' },
					],
					price: [
						{ required: true, message: '请填写月租金', trigger: 'blur' },
						{ type: 'number', min: 0, message: '月租金必须大于0', trigger: 'blur' },
					],
					rentCycle: [{ required: true, message: '请选择支付方式', trigger: 'change' }],
					deposit: [
						{ required: true, message: '请填写押金金额', trigger: 'blur' },
						{ type: 'number', min: 0, message: '押金金额必须大于等于0', trigger: 'blur' },
					],
					content: [{ required: true, message: '请填写租赁条款、双方权利义务', trigger: 'blur' }],
					url: { required: true, message: '请上传附件', trigger: 'blur' },
				},
			};
		},
		methods: {
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
			handleUploadSuccess(res, fileList) {
				this.form.url = fileList.map(item => item.response).join(',');
			},
			handleSubmit() {
				this.$refs.form.validate(valid => {
					if (!valid) return;
					getContractSave({
						...this.form,
					})
						.then(() => {
							this.$message.success('资源签约成功');
							this.$emit('updateSuccess');
						})
						.catch(err => {
							console.log(err);
							this.$message.error('资源签约失败');
						})
						.finally(() => {
							this.handleClose();
						});
				});
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.plan-dialog) {
		.no-spinner .el-input__inner::-webkit-outer-spin-button,
		.no-spinner .el-input__inner::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}

		.no-spinner .el-input__inner[type='number'] {
			-moz-appearance: textfield; /* Firefox */
		}

		.el-dialog__body {
			max-height: 60vh; // 控制最大高度
			overflow-y: auto; // 开启纵向滚动
		}
		/* 整体滚动条宽度 */
		.el-dialog__body::-webkit-scrollbar {
			width: 6px;
		}

		/* 滚动条轨道 */
		.el-dialog__body::-webkit-scrollbar-track {
			background: #f5f5f5;
			border-radius: 3px;
		}

		/* 滑块 */
		.el-dialog__body::-webkit-scrollbar-thumb {
			background: #bbbbbb;
			border-radius: 3px;
			transition: all 0.3s;
		}

		/* hover 时 */
		.el-dialog__body::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}
	}
</style>
